import { render } from "./PassiveContractPage.vue?vue&type=template&id=50c9f46e&scoped=true"
import script from "./PassiveContractPage.vue?vue&type=script&lang=js"
export * from "./PassiveContractPage.vue?vue&type=script&lang=js"

import "./PassiveContractPage.vue?vue&type=style&index=0&id=50c9f46e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c9f46e"]])

export default __exports__